import { render, staticRenderFns } from "./DieselConsumptionPage.vue?vue&type=template&id=11984800&scoped=true&"
import script from "./DieselConsumptionPage.vue?vue&type=script&lang=js&"
export * from "./DieselConsumptionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11984800",
  null
  
)

export default component.exports